import { Pressable, Text, View } from 'react-native'
import { colors } from '@chillout/core'

interface SeriesPillProps {
  label: string
  color: string
  active: boolean
  onPress: () => void
}

export function SeriesPill({ label, color, active, onPress }: SeriesPillProps) {
  return (
    <Pressable
      onPress={onPress}
      accessibilityRole="button"
      accessibilityState={{ selected: active }}
      accessibilityLabel={label}
      className="flex-row items-center gap-1.5 rounded-full border px-3 py-1"
      style={{ borderColor: active ? color : colors.border }}
    >
      <View
        className="h-2 w-2 rounded-full"
        style={{ backgroundColor: active ? color : colors.text.muted }}
      />
      <Text
        className="text-xs font-medium"
        style={{ color: active ? colors.text.primary : colors.text.muted }}
      >
        {label}
      </Text>
    </Pressable>
  )
}